import { render, staticRenderFns } from "./PaymentQrCode.vue?vue&type=template&id=56afa48f&scoped=true&"
import script from "./PaymentQrCode.vue?vue&type=script&lang=js&"
export * from "./PaymentQrCode.vue?vue&type=script&lang=js&"
import style0 from "./PaymentQrCode.vue?vue&type=style&index=0&id=56afa48f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afa48f",
  null
  
)

export default component.exports